import React from 'react';
import './Wave.scss';

const Wave = () => (
  <>
    <div className="wave-effect-first" />
    <div className="wave-effect-second" />
  </>
);

export default Wave;
